import { jsx } from 'react/jsx-runtime';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { useCommandState } from 'cmdk';
import { useState } from 'react';
import { Popover } from '../../popover/patched-popover/PatchedPopover.mjs';
import { SelectSlot } from '../shared/components/slot/Slot.mjs';
import { defaultSearchFilter } from '../shared/utils/default-search-filter.mjs';
import { SelectAnchor as SingleSelectAnchor } from './components/anchor/Anchor.mjs';
import { SelectContentAffix as SingleSelectContentAffix } from './components/content-affix/ContentAffix.mjs';
import { SelectContentFooter as SingleSelectContentFooter } from './components/content-footer/ContentFooter.mjs';
import { SelectContent as SingleSelectContent } from './components/content/Content.mjs';
import { SelectGroupTitle as SingleSelectGroupTitle } from './components/group-title/GroupTitle.mjs';
import { SelectGroup as SingleSelectGroup } from './components/group/Group.mjs';
import { SelectOptionContext as SingleSelectOptionContext } from './components/option-context/OptionContext.mjs';
import { SelectOptionDescription as SingleSelectOptionDescription } from './components/option-description/OptionDescription.mjs';
import { SelectOptionIndicator as SingleSelectOptionIndicator } from './components/option-indicator/OptionIndicator.mjs';
import { SelectOptionTitle as SingleSelectOptionTitle } from './components/option-title/OptionTitle.mjs';
import { SelectOption as SingleSelectOption } from './components/option/Option.mjs';
import { SelectSearchEmpty as SingleSelectSearchEmpty } from './components/search-empty/SearchEmpty.mjs';
import { SelectSearchField as SingleSelectSearchField } from './components/search-field/SearchField.mjs';
import { SelectSearch as SingleSelectSearch } from './components/search/Search.mjs';
import { SelectSeparator as SingleSelectSeparator } from './components/separator/Separator.mjs';
import { SelectTrigger as SingleSelectTrigger } from './components/trigger/Trigger.mjs';
import { SelectValue as SingleSelectValue } from './components/value/Value.mjs';
import { SingleSelectContextProvider } from './contexts/context.mjs';

function SingleSelect({
  children,
  open: openFromProps,
  defaultOpen: defaultOpenFromProps,
  onOpenChange,
  closeOnSelect = true,
  onClose,
  value: valueFromProps,
  defaultValue: defaultValueFromProps,
  onValueChange,
  searchKeyword: searchKeywordFromProps,
  defaultSearchKeyword: defaultSearchKeywordFromProps,
  onSearchKeywordChange,
  loop = false,
  modal = true,
  filter = defaultSearchFilter,
  shouldFilter
}) {
  const [open = false, setOpen] = useControllableState({
    prop: openFromProps,
    defaultProp: defaultOpenFromProps,
    onChange: onOpenChange
  });
  const [value, setValue] = useControllableState({
    prop: valueFromProps,
    defaultProp: defaultValueFromProps,
    onChange: onValueChange
  });
  const [searchKeyword, setSearchKeyword] = useControllableState({
    prop: searchKeywordFromProps,
    defaultProp: defaultSearchKeywordFromProps,
    onChange: onSearchKeywordChange
  });
  const [contentAffixElement, setContentAffixElement] = useState(null);
  const [contentFooterElement, setContentFooterElement] = useState(null);
  return /* @__PURE__ */ jsx(
    SingleSelectContextProvider,
    {
      open,
      onOpenChange: setOpen,
      closeOnSelect,
      onClose,
      value,
      onValueChange: setValue,
      searchKeyword,
      onSearchKeywordChange: setSearchKeyword,
      contentAffixElement,
      onContentAffixElementChange: setContentAffixElement,
      contentFooterElement,
      onContentFooterElementChange: setContentFooterElement,
      loop,
      filter,
      shouldFilter,
      children: /* @__PURE__ */ jsx(Popover, { open, onOpenChange: setOpen, modal, children })
    }
  );
}
SingleSelect.Anchor = SingleSelectAnchor;
SingleSelect.Trigger = SingleSelectTrigger;
SingleSelect.Content = SingleSelectContent;
SingleSelect.ContentAffix = SingleSelectContentAffix;
SingleSelect.ContentFooter = SingleSelectContentFooter;
SingleSelect.Search = SingleSelectSearch;
SingleSelect.SearchField = SingleSelectSearchField;
SingleSelect.SearchEmpty = SingleSelectSearchEmpty;
SingleSelect.Group = SingleSelectGroup;
SingleSelect.GroupTitle = SingleSelectGroupTitle;
SingleSelect.Option = SingleSelectOption;
SingleSelect.OptionTitle = SingleSelectOptionTitle;
SingleSelect.OptionDescription = SingleSelectOptionDescription;
SingleSelect.OptionIndicator = SingleSelectOptionIndicator;
SingleSelect.OptionContext = SingleSelectOptionContext;
SingleSelect.Separator = SingleSelectSeparator;
SingleSelect.Value = SingleSelectValue;
SingleSelect.Slot = SelectSlot;
SingleSelect.useCommandState = useCommandState;

export { SingleSelect as Select };
//# sourceMappingURL=SingleSelect.mjs.map
